import { useCallback } from 'react';
import { get, set } from 'react-hook-form';
import useValidatePreference from './useValidatePreference';

function usePreferenceFormResolver({ category }) {
  const validate = useValidatePreference({ category });

  return useCallback(
    async (values, context, options) => {
      const errors = validate(values);
      const names = Object.keys(errors);

      if (names.length === 0) {
        return { values, errors: {} };
      }

      return {
        values: {},
        errors: names.reduce((acc, name) => {
          const field = get(options.fields, name);

          set(acc, name, {
            type: 'validation',
            message: errors[name],
            ref: field?.ref
          });

          return acc;
        }, {})
      };
    },
    [validate]
  );
}

export default usePreferenceFormResolver;
